import { render, staticRenderFns } from "./indexCanpinSwiper.vue?vue&type=template&id=37c800c4&scoped=true&"
import script from "./indexCanpinSwiper.vue?vue&type=script&lang=js&"
export * from "./indexCanpinSwiper.vue?vue&type=script&lang=js&"
import style1 from "./indexCanpinSwiper.vue?vue&type=style&index=1&id=37c800c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c800c4",
  null
  
)

export default component.exports